import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

import { formatDateTime } from '../../../utils/utils';
import Share from '../share';

class AllNewList extends React.PureComponent {
    render() {
        const { content, moreData } = this.props;
        let prevDate = '';

        return (
            <div className={styles.list}>
                <ul>
                    {content.length > 0
                        ? content.map((item, index) => {
                              const newsTime = formatDateTime(parseInt(item.ctime) * 1000);
                              const date = newsTime.slice(0, 10);
                              const time = newsTime.slice(newsTime.indexOf(' '));
                              const brief = item.brief.replace(/\n\n/g, '<br /><br />').replace(/\n/g, '<br /><br />');

                              if (date !== prevDate) {
                                  prevDate = date;

                                  return (
                                      <React.Fragment key={index}>
                                          <li className={styles.timeTit}>{`${date.slice(0, 4)} 年 ${date.slice(
                                              5,
                                              7,
                                          )} 月 ${date.slice(8)} 日`}</li>
                                          <li className="clearfix">
                                              <p className={styles.time}>{time}</p>
                                              {item.url ? (
                                                  <a href={item.url}>
                                                      <p
                                                          className={styles.title}
                                                          dangerouslySetInnerHTML={{ __html: brief }}
                                                      />
                                                  </a>
                                              ) : (
                                                  <p
                                                      className={styles.title}
                                                      dangerouslySetInnerHTML={{ __html: brief }}
                                                  />
                                              )}
                                              <Share
                                                  url={window.location.href}
                                                  title={item.brief}
                                                  picUrl="http://p0.ifengimg.com/a/2016/0704/finance-logo.png"
                                              />
                                          </li>
                                      </React.Fragment>
                                  );
                              } else {
                                  return (
                                      <li key={index} className="clearfix">
                                          <p className={styles.time}>{time}</p>
                                          {item.url ? (
                                              <a href={item.url}>
                                                  <p
                                                      className={styles.title}
                                                      dangerouslySetInnerHTML={{ __html: brief }}
                                                  />
                                              </a>
                                          ) : (
                                              <p className={styles.title} dangerouslySetInnerHTML={{ __html: brief }} />
                                          )}
                                          <Share
                                              url={window.location.href}
                                              title={item.brief}
                                              picUrl="http://p0.ifengimg.com/a/2016/0704/finance-logo.png"
                                          />
                                      </li>
                                  );
                              }
                          })
                        : ''}
                </ul>
                <div className={styles.more} onClick={moreData}>
                    查看更多
                </div>
            </div>
        );
    }
}

AllNewList.propTypes = {
    content: PropTypes.array,
    moreData: PropTypes.func,
};
AllNewList.defaultProps = {};

export default errorBoundary(AllNewList);
